/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/layout_card_medium'
export default icon
